import type {ReactElement} from 'react';

export interface SelectorPillDropdownContentParams {
  isSmallScreen: boolean;
  closeDropdown: () => void;
}

export interface SelectorPillDropdownProps {
  /** Accessible name of the pill, and the title of the small-screen bottom sheet. */
  title: string;
  pillText: string;
  leadingVisual: ReactElement | null;
  /** Horizontal padding and clipping the pill's content needs; the shared shell owns everything else. */
  pillClassName: string;
  /** Popup width and max-height; the shared shell owns everything else. */
  popupClassName: string;
  panelIdForModal: string;
  modalHeight?: string;
  /** Caps a content-hugging small-screen modal; leave modalHeight unset so the sheet sizes to its content up to this. */
  modalMaxHeight?: string;

  renderPopupContent(params: SelectorPillDropdownContentParams): ReactElement;
}

export const SELECTOR_PILL_POPUP_OFFSET = 8;
export const SELECTOR_PILL_POPUP_SPACING_CLASSES = 'spacing-p-t-2 spacing-p-l-2 spacing-p-r-2';
export const SELECTOR_PILL_MODAL_SPACING_CLASSES = 'spacing-p-t-4 spacing-p-l-4 spacing-p-r-4';
